
import { Component, EventEmitter, inject, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { IndustrySector, IndustrySectorModel } from '../interfaces/GetAllIndustrySectors.interface';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder } from '@angular/forms';
import { ConfermDeleteComponent } from 'app/view/clients/components/conferm-delete/conferm-delete.component';
import { ControlItemsComponent } from './control-items/control-items.component';
import { DomainControlComponent } from 'app/view/mangement/domains/domain-control/domain-control.component';
import { ToastrService } from 'ngx-toastr';
import { IndustrySectorsAndFeildsService } from 'app/shared/services/industry-sectors-and-feilds.service';


@Component({
  selector: 'app-accordion',
  templateUrl: './accordion.component.html',
  styleUrls: ['./accordion.component.scss']
})

// ------------------------------------------ Component create with Eng Ahmed Abdelhameed Ali ------------------------------------------

export class AccordionComponent implements OnInit, OnChanges {

  pageNumber: number = 1;

  control: string = "close";

  lang: string = "";

  @Input() allIndustrySector: IndustrySector[] = [new IndustrySectorModel()]

  @Input() allIndustrySectorFeilds: any[] = []

  @Output() sendIndustrySectorForEdit: EventEmitter<IndustrySector> = new EventEmitter()

  @Output() sendIndustrySectorIDForDelete: EventEmitter<number> = new EventEmitter()

  @Output() sendIndustrySectorFeildIDForDelete: EventEmitter<number> = new EventEmitter()


  constructor(private modalService: NgbModal, private formBuiler: FormBuilder, private IndustrySectorsAndFeilds: IndustrySectorsAndFeildsService, private toastr: ToastrService, public activeModal: NgbActiveModal) { }

  ngOnChanges(changes: any): void {
    this.allIndustrySector = changes.allIndustrySector.currentValue;
  }


  ngOnInit(): void {
    this.lang = JSON.parse(localStorage.getItem('lang_ERP')).lang
  }



  // get Industry Fields for an Industry Sector
  getIndustryFields(id: number) {
    if (this.control == 'open')
      this.IndustrySectorsAndFeilds.getIndustryFields(id).subscribe({
        next: (res: any) => {
          this.allIndustrySector[this.allIndustrySector.indexOf(this.allIndustrySector.find(item => item.id == id))].feilds = res.data
        },
        complete: () => { this.control = 'close'; }
      })
  }

  //  open Control Fields for Edit & delete feilds
  openControlFields(action: string, industrySector: IndustrySector, fieldItem: any) {
    const modalRef = this.modalService.open(ControlItemsComponent, {
      centered: true,
      size: 'lg'
    });
    modalRef.componentInstance.action = action;
    modalRef.componentInstance.industrySector = industrySector;
    modalRef.componentInstance.fieldItem = fieldItem;
  }

  //  open Domain Component for Edit & delete Industry Sector
  openDomainForEdit(item: IndustrySector) {
    const modal = this.modalService.open(DomainControlComponent, {
      centered: true,
      size: 'lg'
    });
    modal.componentInstance.controlView = "edit";
    modal.componentInstance.IndustrySector = item;
    modal.componentInstance.globalIndustryItem = item;
  }

  // show delete alert before the real delete
  showDelete(id: number, type: string) {
    // console.log(id);
    const modalRef = this.modalService.open(ConfermDeleteComponent, {
      centered: true,
      size: 'lg'
    })
    modalRef.componentInstance.id = id;
    modalRef.componentInstance.confirmEvent.subscribe((res) => {
      if (type == 'industry-delete') {
        this.sendIndustrySectorIDForDelete.emit(id);
      this.modalService.dismissAll()
    }
      if (type == 'feild-delete') {
        this.deleteFeild(id)
      }
    })
  }
  // delete Feild from API

  deleteFeild(id: number) {
    this.IndustrySectorsAndFeilds.deleteIndustrySectorFeild(id).subscribe({
      next: (res: any) => { this.toastr.success(res.message); location.reload() },
      error: (res: any) => { this.toastr.error(res.error) },
    })
  }
}
